import { Draft, PayloadAction } from '@reduxjs/toolkit';

import { IInterventionData } from '../../initialState';

export interface IArchiveThreadMessageRequestAction {
  data: {
    id: number;
  };
  functions: {
    close: () => void;
    error: (err: any) => void;
  };
}

function archiveThreadMessageRequest(
  draft: Draft<IInterventionData>,
  _: PayloadAction<IArchiveThreadMessageRequestAction>,
) {
  draft.archiveThreadMessage.config.isLoading = true;
}

export default archiveThreadMessageRequest;
